import { useEffect, useState } from 'react';
import { GameHelper } from 'Helpers/GameHelper';
import { CardObjectType, CardType } from 'Models/Card';
import PointBar from 'Components/AppComponents/PointBar/PointBar';
import { GameState } from 'Components/AppComponents/Game/Game';
import { Ctx } from 'boardgame.io';
import QuestionBox from 'Components/AppComponents/QuestionBox/QuestionBox';
import { OptionsObjectType, QuestionnaireObjectType } from 'Models/Questionnaires';
import useAnimation, { triggerPointTextAnimation } from 'CustomHooks/AnimationHooks/useAnimation';
import CountdownTimer from 'Components/AppComponents/CountdownTimer/CountdownTimer';
import BouncingArrow from 'Components/AppComponents/BouncingArrow/BouncingArrow';
import WinnerMessage from 'Components/AppComponents/WinnerMessage/WinnerMeesage';
import { cardData } from 'Data/Cards';

import 'Assets/css/main.css';
import 'StateContainer.css';
import 'CardMoveSet.css';
import 'PointMove.css';
import Bird from 'Components/AppComponents/Bird/Bird';
import { CARD_DISTRIBUTION_TIME, GAME_COUNTDOWN_TIMER_INTERVAL, HUMAN_PLAYER_DELAY, SHUFFLE_TIME } from 'Constants/GameData';
import LogInPopUp from 'Components/AppComponents/LogInPopUp/LogInPopUp';
import { audios } from 'Constants/AudioData';
import { AudioHelper } from 'Helpers/AudioHelper';

type BoardProps = {
    G: GameState;
    ctx: Ctx;
    moves: any;
    events: any;
};

export const Board = ({ G, ctx, moves, events }: BoardProps) => {
    const [gameStarted, setGameStarted] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [showQuestion, setShowQuestion] = useState(false);
    const [questionnaire, setQuestionnaire] = useState<QuestionnaireObjectType>();
    const [selectedEnergyCard, setSelectedEnergyCard] = useState<any>();
    const [selectedEnergyCardIndex, setSelectedEnergyCardIndex] = useState<any>();
    const [isGameOver, setIsGameOver] = useState(false);
    const [isAnimationRunning, setIsAnimationRunning] = useState(false);
    const [deck, setDeck] = useState<CardObjectType[]>([]);
    const [prevHumanCleanEnergyPercentage, setPrevHumanCleanEnergyPercentage] = useState(GameHelper.calculateCurrentCleanEnergyPercentage(G.humanCleanEnergy));
    const [prevComputerCleanEnergyPercentage, setComputerPrevCleanEnergyPercentage] = useState(GameHelper.calculateCurrentCleanEnergyPercentage(G.computerCleanEnergy));
    const [computerQuestionnaire, setComputerQuestionnaire] = useState<any>();
    const [isLogSubmitted, setIsLogSubmitted] = useState<boolean>(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [cardsDistributed, setCardsDistributed] = useState<boolean>(false);
    const [soundLoaded, setSoundLoaded] = useState<boolean>(false);

    useAnimation({
        currentCleanEnergyPercentage: GameHelper.calculateCurrentCleanEnergyPercentage(G.computerCleanEnergy),
        isLeft: true,
        G,
        ctx,
        events,
        prevCurrentCleanEnergyPercentage: prevComputerCleanEnergyPercentage,
        setPrevCurrentCleanEnergyPercentage: setComputerPrevCleanEnergyPercentage,
        isAnimationRunning,
        setIsAnimationRunning,
        showOverlay,
        showQuestion,
        isGameOver,
        setIsGameOver,
        deck,
        setDeck,
        setComputerQuestionnaire,
        pointLog: G.computerPointLog
    });
    useAnimation({
        currentCleanEnergyPercentage: GameHelper.calculateCurrentCleanEnergyPercentage(G.humanCleanEnergy),
        isLeft: false,
        G,
        ctx,
        events,
        prevCurrentCleanEnergyPercentage: prevHumanCleanEnergyPercentage,
        setPrevCurrentCleanEnergyPercentage: setPrevHumanCleanEnergyPercentage,
        isAnimationRunning,
        setIsAnimationRunning,
        showOverlay,
        showQuestion,
        isGameOver,
        setIsGameOver,
        deck,
        setDeck,
        pointLog: G.humanPointLog
    });

    const isHumanCardClickable = (ctx: Ctx) => {
        if (!showOverlay && ctx.phase === 'gameStart' && !isGameOver && !isAnimationRunning) return true;
        else return false;
    };

    // useEffect(() => {
    //     if (showOverlay) {
    //         document.getElementById('board-container')?.classList.add('blur-on');
    //         setTimeout(() => {
    //             document.getElementById('human-cards')?.classList.add('zoomCards-hover');
    //         }, 1000);
    //     } else {
    //         document.getElementById('human-cards')?.classList.remove('zoomCards-hover');
    //         // if(!showQuestion && !selectedEnergyCard)
    //         document.getElementById('board-container')?.classList.remove('blur-on');
    //     }
    // }, [showOverlay]);

    // useEffect(() => {
    //     if (showQuestion) {
    //         document.getElementById('board-container')?.classList.add('blur-on');
    //     }
    // }, [showQuestion]);

    // useEffect(() => {
    //     if (ctx.gameover?.winner) {
    //         setIsGameOver(true);
    //         document.getElementById('footer-container')!.innerText = ctx.gameover?.winner === '0'? 'You Won.' : 'You Lost.';
    //     }
    // }, [ctx.gameover]);

    useEffect(() => {
        if (window.innerHeight < 883.48) {
            const fullContainer = document.getElementById('full-game-container');
            fullContainer!.style.transform = 'scale(' + (window.innerHeight / 883.48) + ')';
            fullContainer!.classList.remove('m-auto');
            fullContainer!.classList.add('mx-auto');
            // document.getElementById('root')!.style.height = 'auto';
            document.getElementById('root')!.style.overflowY = 'hidden';
        }
        
        AudioHelper.playAll();
        const loadBarEl = document.getElementById('load-bar');
        const images = cardData.map((x) => x.ImageUrl);
        images.push('/cards/Back.jpg');
        images.push('/cards/Pattern.jpg');
        let count = [];
        images.forEach((element) => {
            const img = new Image();
            img.src = element;
            img.onload = () => {
                count.push(img);
                if (count.length === images.length - 1) {
                    audios.forEach(audio => {
                        audio.oncanplaythrough = () => {
                            count.push(audio);
                            console.log(audio);
                            if (count.length === (images.length + audios.length - 1)) {
                                console.log(audio);
                                loadBarEl!.style.width = '100%';
                                document.getElementById('loading-bar-container')?.classList.add('load-bar-container');
                                setIsLoaded(true);
                            } else {
                                loadBarEl!.style.width = ((Number(loadBarEl!.style.width.split('%')[0]) + (100 / (images.length + audios.length))) + '%');
                            }
                        }
                        
                        setTimeout(() => {
                            audio.load();
                        }, 10);                                                
                    });
                    // loadBarEl!.style.width = '100%';
                    // document.getElementById('loading-bar-container')?.classList.add('load-bar-container');
                    // setIsLoaded(true);
                } else {
                    loadBarEl!.style.width = ((Number(loadBarEl!.style.width.split('%')[0]) + (100 / (images.length + audios.length))) + '%');
                }
            }
        });
    }, []);

    useEffect(() => {
        if (ctx.phase === 'cardDistribution' && isLogSubmitted && cardsDistributed) {
            if (G.computerCards.length === 5 && G.humanCards.length === 5) {
                setTimeout(() => {
                    triggerGameStartCountdown('game-timer', ['hidden'], events);                    
                    setTimeout(() => {
                        AudioHelper.playSound('Start_Game_Countdown');
                    }, 1000);  
                    setTimeout(() => {
                        if(!ctx.gameover?.winner) document.getElementById('footer-container')!.innerText = GameHelper.userTurn;
                    }, 5000);
                }, 1000);
            }
        }
    }, [isLogSubmitted, cardsDistributed]);    

    useEffect(() => {
        if (deck.length === 0 && isLogSubmitted) {
            setTimeout(
                () => {
                    setDeck(!gameStarted? [...G.deck.Cards, ...G.computerCards, ...G.humanCards] : G.deck.Cards);
                    const element = document.getElementById('deck-container');
                    if (element && element?.children?.length > 0) {
                        setTimeout(() => {
                            const distribute = !gameStarted;
                            document.getElementById('footer-container')!.innerText = gameStarted ? GameHelper.shuffleMessage : '';
                            if (gameStarted) {
                                document.getElementById('footer-container')!.classList.add('loading-text-white');
                            }
                            AudioHelper.playSound('shuffling_cards_2');
                            Array.from(element.children).forEach((child, index) => {
                                const tempChild = child as HTMLElement;
                                setTimeout(() => {
                                    tempChild.style.transform = `translate(${0.25 * index}px, -${0.25 * index}px)`;
                                }, index * ((SHUFFLE_TIME) / (element.children.length)));
                            });

                            if(distribute) {
                                const distributedCards = Array.from(element.children).slice(-10);
                                setTimeout(() => {                                    
                                    setTimeout(() => {
                                        (distributedCards[0] as HTMLElement).style.transform = `translate(-345px, 16px) rotate(-15deg)`;
                                        // (distributedCards[0] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[0] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*9));  

                                    setTimeout(() => {
                                        (distributedCards[1] as HTMLElement).style.transform = `translate(255px, 16px) rotate(-15deg)`;
                                        // (distributedCards[1] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[1] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*8));

                                    setTimeout(() => {
                                        (distributedCards[2] as HTMLElement).style.transform = `translate(-325px, 1px) rotate(-7.5deg)`;
                                        // (distributedCards[2] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[2] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*7));

                                    setTimeout(() => {
                                        (distributedCards[3] as HTMLElement).style.transform = `translate(274px, 1px) rotate(-7.5deg)`;
                                        // (distributedCards[3] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[3] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*6));

                                    setTimeout(() => {
                                        (distributedCards[4] as HTMLElement).style.transform = `translate(-300px, -9px)`;
                                        // (distributedCards[4] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[4] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*5));

                                    setTimeout(() => {
                                        (distributedCards[5] as HTMLElement).style.transform = `translate(300px, -9px)`;
                                        // (distributedCards[5] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[5] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*4));

                                    setTimeout(() => {
                                        (distributedCards[6] as HTMLElement).style.transform = `translate(-275px, 1px) rotate(7.5deg)`;
                                        // (distributedCards[6] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[6] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*3));

                                    setTimeout(() => {
                                        (distributedCards[7] as HTMLElement).style.transform = `translate(325px, 1px) rotate(7.5deg)`;
                                        // (distributedCards[7] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[7] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (((CARD_DISTRIBUTION_TIME-500)/10)*2));

                                    setTimeout(() => {
                                        (distributedCards[8] as HTMLElement).style.transform = `translate(-255px, 16px) rotate(15deg)`;
                                        // (distributedCards[8] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                        (distributedCards[8] as HTMLElement).classList.remove('card-less-shadow');
                                    }, (CARD_DISTRIBUTION_TIME-500)/10);

                                    // setTimeout(() => {
                                    (distributedCards[9] as HTMLElement).style.transform = `translate(345px, 16px) rotate(15deg)`;
                                    (distributedCards[9] as HTMLElement).classList.remove('card-less-shadow');
                                        // (distributedCards[9] as HTMLElement).style.boxShadow = `rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px, rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px, rgb(0 0 0 / 9%) 0px -3px 5px !important`;
                                    // }, 100);
                                }, SHUFFLE_TIME + 1000);

                                setTimeout(() => {
                                    setDeck(G.deck.Cards);
                                    const humanCards = document.getElementById('human-cards');                                
                                    setTimeout(() => {
                                        setTimeout(() => {
                                            setCardsDistributed(true);
                                        }, 500);                                    

                                        Array.from(humanCards!.children).forEach((child, index) => {
                                            setTimeout(() => {
                                                AudioHelper.playSound('WHOOSH');
                                                const tempChild = child as HTMLElement;
                                                tempChild.classList.remove('rotated');
                                            }, 300*index);                                        
                                        });
                                        setTimeout(() => {
                                            Array.from(humanCards!.children).forEach((child, index) => {
                                                const tempChild = child as HTMLElement;
                                                tempChild.firstElementChild?.classList.remove('duration-500');
                                            }); 
                                        }, 1500);
                                    }, 500);
                                    
                                }, (SHUFFLE_TIME + CARD_DISTRIBUTION_TIME + 1000));
                            } else {

                            }
                            

                            

                            // if (distribute) {
                            //     const humanCards = document.getElementById('human-cards');
                            //     Array.from(humanCards!.children).forEach((child, index) => {
                            //         const tempChild = child as HTMLElement;
                            //         tempChild.classList.add('card-less-shadow'); 
                            //         tempChild.style.zIndex = '' + (10000 + (1000 * index * 2));                                   
                            //         setTimeout(() => {
                            //             tempChild.classList.remove('initial-human-state');  
                            //             tempChild.style.transform = `translate(-${(100 * (index+1)) - 0.25 * (element.children.length + (index*2))}px, ${9 - 0.25 * (element.children.length + (index*2))}px)`;
                            //         }, (element.children.length + (index * 2)) * ((SHUFFLE_TIME - 1500) / (element.children.length + 10)));
                            //     });

                            //     const computerCards = document.getElementById('computer-cards');
                            //     Array.from(computerCards!.children).forEach((child, index) => {
                            //         const tempChild = child as HTMLElement;
                            //         tempChild.classList.add('card-less-shadow');
                            //         tempChild.style.zIndex = '' + (10000 + (1000 * ((index * 2)+1)));
                            //         setTimeout(() => {
                            //             tempChild.style.transform = `translate(${(500 - (100*index)) + 0.25 * (element.children.length + (index*2) + 1)}px, ${9 - 0.25 * (element.children.length + (index*2) + 1)}px)`;
                            //         }, (element.children.length + (index * 2) + 1) * ((SHUFFLE_TIME - 1500) / (element.children.length + 10)));
                            //     });    
                                
                            //     setTimeout(() => {
                            //         computerCards?.classList.remove('initial-computer-state');

                            //         Array.from(humanCards!.children).forEach((child, index) => {
                            //             const tempChild = child as HTMLElement;                             
                            //             setTimeout(() => {
                            //                 tempChild.classList.remove('card-less-shadow');
                            //                 tempChild.classList.remove('rotated');  
                            //                 tempChild.style.removeProperty("transform");
                            //             }, 150 * (((4-index) * 2) + 1));
                            //         });

                            //         Array.from(computerCards!.children).forEach((child, index) => {
                            //             const tempChild = child as HTMLElement;
                            //             setTimeout(() => {
                            //                 tempChild.classList.remove('card-less-shadow');       
                            //                 tempChild.style.removeProperty("transform");
                            //             }, 150 * (((4-index) * 2)));
                            //         });

                            //         setTimeout(() => {
                            //             Array.from(humanCards!.children).forEach((child, index) => {
                            //                 const tempChild = child as HTMLElement;
                            //                 tempChild.firstElementChild?.classList.remove('duration-500');
                            //             });                                        
                            //         }, 1500);
                            //         setCardsDistributed(true);
                            //     }, SHUFFLE_TIME - 500);
                            // }
                            setTimeout(() => {
                                setIsAnimationRunning(false);
                                document.getElementById('footer-container')!.classList.remove('loading-text-white');
                                document.getElementById('footer-container')!.innerText = gameStarted? GameHelper.userTurn : '';
                            }, (SHUFFLE_TIME - 1000));
                        }, 100);
                    }
                    setGameStarted(true);
                },
                gameStarted ? 3000 : 0
            );
        }
    }, [deck, isLogSubmitted]);


    const triggerGameStartCountdown = (id: string, classes: string[], events: any) => {
        const divTag = document.getElementById(id)! as HTMLParagraphElement;   
        if (divTag) {
            divTag.classList.remove(...classes);
            divTag.classList.add('timer-fade');                      
            setTimeout(() => {
                divTag.classList.add(...classes);
                events?.endPhase();
            }, GAME_COUNTDOWN_TIMER_INTERVAL);
        }
    };

    const handleCardClick = (clickedCardIdx: number) => {
        const element = document.getElementById(clickedCardIdx + '-human-card');
        AudioHelper.playSound('Card_and_Answer_Selection');
        setTimeout(() => {
            if(G.humanCards[clickedCardIdx].Type === CardType.Renewable) {
                AudioHelper.playSound('Renewable_Energy_card_chee_hoo');
            } else if (G.humanCards[clickedCardIdx].Type === CardType.FossilFuel) {
                AudioHelper.playSound('Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed');
            }
        }, 300);
        setSelectedEnergyCardIndex(clickedCardIdx);
        if (showOverlay && element) {
            setIsAnimationRunning(true);            
            element?.classList.add('selected-card-' + (clickedCardIdx + 1));
            setTimeout(() => {
                if (G.humanCards[clickedCardIdx].Type !== CardType.Energy) {                    
                    const check = G.humanCards[clickedCardIdx].Type === CardType.Saver || G.humanCards[clickedCardIdx].Type === CardType.Renewable;
                    element?.classList.add('execute-card');
                    AudioHelper.playSound('Card_Transfer_Deck_to_Across_Screen_slow_down');
                    setTimeout(() => {                        
                        moves.playCard(clickedCardIdx);
                    }, 1000);
                    triggerPointTextAnimation(check ? 'humanCleanPointMove' : 'computerDirtyPointMove', [check ? 'humanCleanPointMove' : 'computerDirtyPointMove'], `+${G.humanCards[clickedCardIdx].CardValue}`);
                    document.getElementById('board-container')?.classList.remove('blur-on');
                    document.getElementById('footer-container')!.innerText = check ? GameHelper.cleanEnergyAddedToGrid('0', G.humanCards[clickedCardIdx].CardValue) : GameHelper.dirtyEnergyThrownToGrid('0', G.humanCards[clickedCardIdx].CardValue);
                }
            }, 500 + HUMAN_PLAYER_DELAY);

            setTimeout(
                () => {
                    if (G.humanCards[clickedCardIdx].Type === CardType.Energy) {
                        element?.classList.remove('duration-1000');
                        element?.classList.add('duration-500');
                        element?.classList.add('flip-quiz-card');
                        setTimeout(() => {
                            element?.classList.remove('duration-500');
                        }, 500);
                        setQuestionnaire(G.humanCards[clickedCardIdx].Questionnaire!);
                        setShowOverlay(false);
                        setShowQuestion(true);
                        setSelectedEnergyCard(clickedCardIdx);
                    } else {
                        element?.classList.remove('duration-1000');
                        element?.classList.add('card-less-shadow');
                        element?.classList.add('rotated');
                        // element?.classList.add('get-card');

                        switch (clickedCardIdx) {
                            case 0:
                                element.style.transform = `translate(-${100 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                                break;

                            case 1:
                                element.style.transform = `translate(-${200 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                                break;

                            case 2:
                                element.style.transform = `translate(-${300 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                                break;

                            case 3:
                                element.style.transform = `translate(-${400 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                                break;

                            case 4:
                                element.style.transform = `translate(-${500 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                                break;
                        }
                        setDeck(deck.filter((x, i) => i !== deck.length - 1));
                        element?.classList.remove('selected-card-' + (clickedCardIdx + 1));
                        element?.classList.remove('execute-card');
                        setTimeout(() => {
                            document.getElementById('deck-container')?.classList.add('human-draw-card');
                            element?.classList.add('duration-1000');
                            element?.getElementsByClassName('flip-card-inner')[0].classList.add('duration-1000');
                            setTimeout(() => {
                                AudioHelper.playSound('Card_Flip_2nd_sound');
                                document.getElementById('deck-container')?.classList.remove('human-draw-card');
                                // element?.classList.remove('get-card');
                                element?.style.removeProperty('transform');
                                element?.classList.remove('card-less-shadow');
                                element?.classList.remove('rotated');
                                setTimeout(() => {
                                    element?.getElementsByClassName('flip-card-inner')[0].classList.remove('duration-1000');
                                }, 1000);
                            }, 1000);
                        }, 1000);
                    }
                },
                G.humanCards[clickedCardIdx].Type === CardType.Energy ? 1500 : (1500 + HUMAN_PLAYER_DELAY)
            );
            setShowOverlay(!showOverlay);
        }
    };

    const handleAnswerSubmit = (answers: number[]) => {
        const correctAnswers: number[] = [];
        G.humanCards[selectedEnergyCardIndex].Questionnaire?.Options.forEach((opt: OptionsObjectType, idx: number) => (opt.IsAnswer ? correctAnswers.push(idx) : null));
        let answerNotFound = false;
        if (correctAnswers.length === answers?.length) {
            for (let index = 0; index < correctAnswers.length; index++) {
                if (!answers.includes(correctAnswers[index])) {
                    answerNotFound = true;
                    break;
                }
            }
            if (answerNotFound === false) {
                triggerPointTextAnimation('humanCleanPointMove', ['humanCleanPointMove'], `+${G.humanCards[selectedEnergyCardIndex].CardValue}`);
                document.getElementById('footer-container')!.innerText = GameHelper.quizCorrectAnswerMessage('0', G.humanCards[selectedEnergyCardIndex].CardValue);
            }
        } else {
            answerNotFound = true;
        }
        if (answerNotFound === true) {
            triggerPointTextAnimation('humanDirtyPointMove', ['humanDirtyPointMove'], `+${G.humanCards[selectedEnergyCardIndex].CardValue}`);
            document.getElementById('footer-container')!.innerText = GameHelper.quizWrongAnswerMessage('0', G.humanCards[selectedEnergyCardIndex].CardValue);

            // document.getElementById('footer-container')!.innerText = `${G.humanCards[selectedEnergyCardIndex].CardValue}kW dirty energy was added to your grid.`;
        }
        setTimeout(() => {
            setShowQuestion(false);

            moves.playCard(selectedEnergyCard, answers);

            const element = document.getElementById(selectedEnergyCardIndex + '-human-card');
            element?.classList.remove('flip-quiz-card');
            element?.classList.remove('duration-1000');
            element?.classList.add('card-less-shadow');
            element?.classList.add('rotated');
            // element?.classList.add('get-card');
            switch (selectedEnergyCardIndex) {
                case 0:
                    element!.style.transform = `translate(-${100 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                    break;

                case 1:
                    element!.style.transform = `translate(-${200 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                    break;

                case 2:
                    element!.style.transform = `translate(-${300 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                    break;

                case 3:
                    element!.style.transform = `translate(-${400 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                    break;

                case 4:
                    element!.style.transform = `translate(-${500 - 0.25 * (deck.length - 1)}px, ${9 - 0.25 * (deck.length - 1)}px)`;
                    break;
            }
            setDeck(deck.filter((x, i) => i !== deck.length - 1));
            element?.classList.remove('selected-card-' + (selectedEnergyCardIndex + 1));
            element?.classList.remove('execute-card');
            setTimeout(() => {
                document.getElementById('deck-container')?.classList.add('human-draw-card');
                element?.classList.add('duration-1000');
                element?.getElementsByClassName('flip-card-inner')[0].classList.add('duration-1000');
                setTimeout(() => {
                    AudioHelper.playSound('Card_Flip_2nd_sound');
                    document.getElementById('deck-container')?.classList.remove('human-draw-card');
                    // element?.classList.remove('get-card');
                    element?.style.removeProperty('transform');
                    element?.classList.remove('card-less-shadow');
                    element?.classList.remove('rotated');
                    setTimeout(() => {
                        element?.getElementsByClassName('flip-card-inner')[0].classList.remove('duration-1000');
                    }, 1000);
                }, 1000);
            }, 1000);
        }, 1000);
    };

    return (
        <>
            <div
                className="flex justify-center board-div m-auto "
                onClick={() => {
                    if (showOverlay) setShowOverlay(false);
                }}
            >
                <div
                    className="board-div flex absolute overflow-hidden"
                >
                    <div className="flex justify-between w-full grayscale-100" style={{ zIndex: 200 }}>
                        <PointBar currentCleanEnergyPercentage={GameHelper.calculateCurrentCleanEnergyPercentage(G.computerCleanEnergy)} />
                        <PointBar currentCleanEnergyPercentage={GameHelper.calculateCurrentCleanEnergyPercentage(G.humanCleanEnergy)} isLeft={false} />
                    </div>

                    <div id="overlay-container" className={`w-full h-full flex duration-1000`} style={{ zIndex: 100 }}>
                        <div id="1-blackout-overlay" className="w-1/2 h-full duration-1000"></div>
                        <div id="0-blackout-overlay" className="w-1/2 h-full duration-1000"></div>
                    </div>

                    <CountdownTimer />
                    <WinnerMessage won={ctx.gameover?.winner === '0'} appear={isGameOver} />

                    <img src="images/Smoke01.png" alt="smoke" id="computer-smoke-1" className="smoke" style={{ width: '126px', top: '3%', left: '3%' }} />
                    <img src="images/Smoke02.png" alt="smoke" id="computer-smoke-2" className="smoke" style={{ width: '111px', top: '3%', left: '2.4%' }} />
                    <img src="images/Smoke03.png" alt="smoke" id="computer-smoke-3" className="smoke" style={{ width: '111px', top: '5%', left: '3%' }} />

                    <img src="images/Smoke01.png" alt="smoke" id="human-smoke-1" className="smoke" style={{ width: '126px', top: '3%', left: '57%' }} />
                    <img src="images/Smoke02.png" alt="smoke" id="human-smoke-2" className="smoke" style={{ width: '111px', top: '3%', left: '56.3%' }} />
                    <img src="images/Smoke03.png" alt="smoke" id="human-smoke-3" className="smoke" style={{ width: '111px', top: '5%', left: '56%' }} />

                    {/* Human side birds */}
                    <Bird id="human-bird-1" birdStyles={{top: '4%', right: '10%'}} translateToX="110px" translateToY="-45px" />
                    <Bird id="human-bird-2" birdStyles={{top: '17%', right: '4%'}} translateToX="60px" translateToY="-50px" />
                    <Bird id="human-bird-3" birdStyles={{top: '14%', right: '11%'}} translateToX="145px" translateToY="-100px" />

                    {/* AI side birds */}
                    <Bird id="computer-bird-1" birdStyles={{top: '4%', right: '64%'}} translateToX="100px" translateToY="-45px" />
                    <Bird id="computer-bird-2" birdStyles={{top: '17%', right: '58%'}} translateToX="90px" translateToY="-140px" />
                    <Bird id="computer-bird-3" birdStyles={{top: '14%', right: '65%'}} translateToX="150px" translateToY="-115px" />

                    {/* AI tower section with lights */}
                    <>
                        {/* top-left light */}
                        <img src="images/Light01.png" alt="light" className="top-left-light fade blur-8" style={{ top: '33%', left: '10%' }} />

                        {/* top-right light */}
                        <img src="images/Light02.png" alt="light" className="top-right-light fade blur-8" style={{ top: '32%', left: '29%' }} />

                        {/* tower */}
                        <img src="images/TransmissionTower.png" alt="tower" id="computer-tower" className="tower blur-8" style={{ top: '41%', left: '18%' }} />

                        {/* bottom-left light */}
                        <img src="images/Light04.png" alt="light" className="bottom-left-light fade blur-8" style={{ top: '53%', left: '11%' }} />

                        {/* bottom-right light */}
                        {/* <img src="images/Light03.png" className="bottom-right-light fade" style={{ top: '52%', left: '29%' }} /> */}
                    </>

                    {/* Human tower section with lights */}
                    <>
                        {/* top-left light */}
                        <img src="images/Light01.png" alt="light" className="top-left-light fade blur-8" style={{ top: '33%', left: '57%' }} />

                        {/* top-right light */}
                        <img src="images/Light02.png" alt="light" className="top-right-light fade blur-8" style={{ top: '32%', left: '76%' }} />

                        {/* tower */}
                        <img src="images/TransmissionTower.png" alt="tower" id="human-tower" className="tower blur-8" style={{ top: '43%', left: '65%' }} />

                        {/* bottom-left light */}
                        <img src="images/Light04.png" alt="light" className="bottom-left-light fade blur-8" style={{ top: '55%', left: '58%' }} />

                        {/* bottom-right light */}
                        <img src="images/Light03.png" alt="light" className="bottom-right-light fade blur-8" style={{ top: '52%', left: '76%' }} />
                    </>

                    <div className="flex justify-around w-full shadow-lg grayscale-100" style={{ zIndex: 200, bottom: '75px', left: '-40px' }}>
                        <div className="deck-container flex" id="deck-container">
                            {deck.map((card: CardObjectType, idx: number) => (
                                <img
                                    className="absolute w-20 card card-less-shadow duration-1000"
                                    alt="deck"
                                    key={idx}
                                    src="/cards/Back.jpg"
                                    id={'deck-card-'+(idx+1)}
                                    style={{ transform: `translate(${idx % 2 === 0 ? -200 + 0.25 * idx : 200 + 0.25 * idx}px, ${-(-200 + 0.25 * idx)}px)`, transition: `all ${((SHUFFLE_TIME - 1000)/1000) / deck.length + 0.6}s` }}
                                />
                            ))}
                        </div>
                    </div>

                    {/* bolt fade in fade out */}
                    <>
                        <i className="bolt" id="computer-negative-label" style={{ top: '9%', left: '7.7%' }} />
                        <i className="bolt" id="computer-positive-label" style={{ top: '9%', left: '37.25%' }} />
                        <i className="bolt" id="human-negative-label" style={{ top: '9%', left: '61.8%' }} />
                        <i className="bolt" id="human-positive-label" style={{ top: '9%', left: '91.5%' }} />
                    </>

                    {/* point text */}
                    <p id="humanCleanPointMove" className="text-xl text-white" style={{ top: '51%', left: '45%', zIndex: 100000000 }} />
                    <p id="humanDirtyPointMove" className="text-xl text-white" style={{ top: '51%', left: '45%', zIndex: 100000000 }} />
                    <p id="computerCleanPointMove" className="text-xl text-white" style={{ top: '51%', left: '45%', zIndex: 100000000 }} />
                    <p id="computerDirtyPointMove" className="text-xl text-white" style={{ top: '51%', left: '45%', zIndex: 100000000 }} />

                    <div className="flex justify-around w-full bottom-3 grayscale-100" style={{ zIndex: 200 }}>
                        {((deck.length !== 0 || gameStarted) && deck.length <= (cardData.length-10)) && <><div id="computer-cards" className="flex space-x-5 hand-cards">
                            {/* initial-computer-state */}
                            {G.computerCards.map((card: CardObjectType, idx: number) => (
                                <div className="flip-card w-20 card duration-1000 computer-card-distribute" key={idx + '-computer-card'} id={idx + '-computer-card'}>
                                    <div className="flip-card-inner  duration-500">
                                        <div className="flip-card-front">
                                            <img alt="computer-cards-front" key={idx} src="/cards/Back.jpg" />
                                        </div>
                                        <div className="flip-card-back">
                                            <img alt="computer-cards-back" id={idx + '-computer-card-img'} src={card.ImageUrl} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div
                            id="human-cards"
                            className={`flex space-x-5 duration-1000 ${showOverlay ? 'zoomCards' : 'hand-cards'} ${isHumanCardClickable(ctx) ? 'cursor-pointer' : 'cursor-default'}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (isHumanCardClickable(ctx)) setShowOverlay(!showOverlay);
                            }}
                        >
                            {G.humanCards.map((card: CardObjectType, idx: number) => (
                                <div className="flip-card w-20 rotated card duration-1000" key={idx + '-human-card'} id={idx + '-human-card'} onClick={() => (showOverlay && !isGameOver ? handleCardClick(idx) : null)}>
                                    {/* rotated initial-human-state */}
                                    <div className="flip-card-inner duration-500">
                                        {/* duration-500 */}
                                        <div className="flip-card-front">
                                            <img alt="human-cards-front" src={card.ImageUrl} />
                                        </div>
                                        <div className="flip-card-back">
                                            <img alt="human-cards-back" key={idx} src="/cards/Back.jpg" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div></>}
                    </div>

                    <BouncingArrow appear={isHumanCardClickable(ctx)} />
                    {showQuestion && questionnaire && (
                        <div className="flex justify-center items-center h-full w-full">
                            <QuestionBox questionnaire={questionnaire} setAnswers={handleAnswerSubmit} />
                        </div>
                    )}

                    {computerQuestionnaire?.showComputerQuestion && (
                        <div className="flex justify-center items-center h-full w-full">
                            <QuestionBox questionnaire={computerQuestionnaire.questionnaire} computerQuestion={true} correctAnswer={computerQuestionnaire.correctAnswer? true : false} />
                        </div>
                    )}

                    

                    
                </div>
                {!isLogSubmitted && <div className="flex justify-center items-center h-full w-full">
                    <LogInPopUp onSubmitCompletion={() => setIsLogSubmitted(true)} showPopup={isLoaded} G={G} />
                </div>}
            </div>

            <div
                id="footer-container"
                className="p-3 text-center text-white"
                style={{
                    textShadow: '2px 2px 5px #000',
                    minHeight: '54px',
                    fontFamily: 'Monster Mash',
                    fontSize: '20px',
                    backgroundColor: 'rgba(58,58,58,0.7)',
                }}
            ></div>
        </>
    );
};
